import React from 'react';
import * as ds from './dataService';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import {
  InspectionResultSelectField,
  SelectInspectorField
} from 'modules/components/layer04';
import { Stack } from '@mui/material';
import { SaveInspection_Input } from 'generated/graphql';
import { DateTime } from 'luxon';

export type SaveInspectionFormProps = {
  id: string;
  projectId: string;
  milestoneId?: string;
  handleClose: () => void;
};

export const FC = (props: SaveInspectionFormProps) => {
  const [
    fnSaveInspectionForm,
    { loading }
  ] = ds.useSaveInspection();
  const form = ds.useFormState(props.id, props.projectId);
  const handleSubmit = async (input: ds.IFormState) => {
    input;
    const tempInput: SaveInspection_Input = {
      id: input.id === '' ? undefined : input.id,
      description: input.description,
      inspectedSystem: input.inspectedSystem,
      inspectionResultId: input.inspectionResultId,
      projectId: input.projectId,
      dateInspected: form.formState.dateInspected === '' ? null : DateTime.fromFormat(form.formState.dateInspected, 'yyyy-LL-dd'),
      inspectedBy: form.formState.inspectedById !== ''
        ? {
          id: form.formState.inspectedById ?? ''
        }
        : null
    };

    await fnSaveInspectionForm(tempInput);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      {/* ADD FIELDS */}
      <Stack
        rowGap='1.5rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('dateInspected')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('inspectedSystem')}
        />
        <SelectInspectorField.FC
          form={form}
          fieldName='inspectedById'
        />
        {/* <StyledTextField.FC
          {...form.genFieldProps('inspectedById')}
        /> */}
        <StyledTextField.FC
          {...form.genFieldProps('description')}
          multiline={true}
        />
        <InspectionResultSelectField.FC
          form={form}
          fieldName='inspectionResultId'
        />
      </Stack>
    </FormBaseLayout.FC>

  );
};
